













import { defineComponent } from "@vue/composition-api";
import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";
import BaseIcon from "@/components/Base/BaseIcon";
import NotificationItemView from "../../NotificationItemView.vue";

export default defineComponent({
  name: "NotificationFullCreatorApplicationApproved",
  components: { BaseIcon, NotificationItemView },
  props: {
    notification: { type: Object as () => Notification, required: true },
  },
});
